import React from 'react';
import { useSolubilityStore } from '../store/useSolubilityStore';

export function SolubilityTable() {
  const results = useSolubilityStore(s => s.results);
  const sorted = [...results].sort((a, b) => a.trialId - b.trialId);

  return (
    <div className="flex flex-col h-full">
      <h2 className="text-lg font-bold mb-3">Trial Results</h2>
      {sorted.length === 0 && (
        <p className="text-sm text-muted-foreground">Complete a trial and press <em>Record Observation</em> to populate this table.</p>
      )}
      {sorted.length > 0 && (
        <div className="overflow-x-auto rounded-lg border border-border">
          <table className="w-full text-sm">
            <thead className="bg-muted/40">
              <tr>
                <th className="p-2 text-left font-semibold">Trial</th>
                <th className="p-2 text-left font-semibold">Temp (°C)</th>
                <th className="p-2 text-left font-semibold">Salt Added (g)</th>
                <th className="p-2 text-left font-semibold">Dissolved (g)</th>
                <th className="p-2 text-left font-semibold">Undissolved (g)</th>
                <th className="p-2 text-left font-semibold">Observation</th>
              </tr>
            </thead>
            <tbody>
              {sorted.map(r => (
                <tr key={r.trialId} className="border-t border-border">
                  <td className="p-2 font-mono">{r.trialId}</td>
                  <td className="p-2 font-mono">{r.finalTempC.toFixed(1)}</td>
                  <td className="p-2 font-mono">{r.saltMassG}</td>
                  <td className="p-2 font-mono text-emerald-600 dark:text-emerald-400">{r.dissolvedMassG}</td>
                  <td className="p-2 font-mono text-amber-600 dark:text-amber-400">{r.undissolvedMassG}</td>
                  <td className="p-2 text-xs text-muted-foreground">{r.observation}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default SolubilityTable;
